<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'FORMADESEMBOLSO.LBL_ESPECIES' | translate}}</h1>
  </div>
</div>
<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="idFormulario" name="nomFormulario">

    <div class="grid">
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'FORMADESEMBOLSO.LBL_CODIGO' | translate }}</label>
          <div *ngIf="formaDesembolso && formaDesembolso.idFormaDesembolso">
            <label class="falso-combo-texto">{{formaDesembolso.codigo}}</label>
          </div>
          <div *ngIf="!formaDesembolso">
            <input *ngIf="!formaDesembolso" type="text" pInputText id="codigo"
                   name="nomCodigo"
                   autocomplete="off"
                   formControlName="codigo"
                   [maxlength]="10"
                   codigos-reactive
            >
            <div class="p-message p-messages-error p-corner-all"
                 *ngIf="!formaDesembolso && submitted && f.codigo.invalid">
              {{ 'FORMADESEMBOLSO.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3">
        <div class="div-form">
          <label>* {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate }}</label>
          <input type="text" pInputText id="nombre"
                 name="nomNombre"
                 autocomplete="off"
                 formControlName="nombre" capitalize-reactive
                 [maxlength]="50"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
            {{ 'FORMADESEMBOLSO.LBL_TIPOESPECIE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 ">
        <div class="div-form">
          <label>* {{ 'FORMADESEMBOLSO.LBL_PORMAXDES' | translate }}</label>
          <input type="text" pInputText id="porcentaje"
                 name="nomPorcentaje"
                 autocomplete="off"
                 formControlName="porcentaje"
                 porcentaje-reactive
                 [maximo]="100"
                 [decimales]="2"
                 [maxlength]="6"
          >
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.porcentaje.invalid">
            {{ 'FORMADESEMBOLSO.LBL_PORMAXDES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 ">
        <p-checkbox label="{{ 'FORMADESEMBOLSO.LBL_HABILITADO' | translate}}" binary="true"
                    id="indicadorHabilitado"
                    name="nomIndicadorHabilitado"
                    formControlName="indicadorHabilitado"></p-checkbox>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'LBL_DESCRIPCIONESPECIE' | translate }}</label>
          <textarea pInputTextarea id="descripcion" name="descripcion" formControlName="descripcion"
                    maxlength="250"></textarea>
          <div class="p-message p-messages-error p-corner-all"
               *ngIf="submitted && f.descripcion.invalid">
            {{ 'LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <div class="grid form-footer-buttons" *ngIf="formaDesembolso">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-refresh" label="{{'BTN_ACTUALIZAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons" *ngIf="!formaDesembolso">
      <div class="form-group col-12">
        <div *ngIf="!guardando">
          <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                  type="submit"
                  pButton></button>
        </div>
        <div *ngIf="guardando">
          <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
          <span>{{'LBL_GUARDANDO' | translate }}</span>
        </div>
      </div>
    </div>
  </form>
  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6 md:col-offset-6 lg:col-offset-6">
      <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')"
             [(ngModel)]="busqueda" (change)="setBusqueda()">
    </div>
  </div>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [loading]="carTabla" #dt
               [value]="lisFormaDesembolso" selectionMode="single" dataKey="nombre"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigo}}</td>
            <td>{{row.nombre}}</td>
            <td>{{row.porcentaje}} %</td>
            <td>{{row.descripcion}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" [disabled]="true"></p-checkbox>
            </td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                        title="{{'BTN_EDITAR' | translate}}" pButton
                        (click)="editar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>
<p-confirmDialog #cd key="categoria">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
